import { EdgeDistanceToggleType } from '@/enums/EdgeDistanceToggleType'
import { EdgeArrow } from '@cfs-fixings/shared'
import classNames from 'classnames'

type MainPropTypes = {
  values?: {
    positiveY?: boolean,
    negativeY?: boolean,
    positiveX?: boolean,
    negativeX?: boolean,
    thickness?: boolean,
  },
  onToggle?: (value: boolean, type: EdgeDistanceToggleType) => void,
}

type TogglePropTypes = {
  children?: React.ReactNode,
  value?: boolean,
  onClick?: () => void,
}

const EdgeDistanceToggle = ({ values, onToggle }: MainPropTypes) => {
  return (
    <div className="flex w-full justify-center items-center">
      <div className="grid grid-cols-3 grid-rows-3 w-[80px] gap-2">
        <div className="flex justify-center col-span-3">
          <Toggle
            value={values?.positiveY}
            onClick={() => onToggle?.(!(values?.positiveY ?? false), EdgeDistanceToggleType.PositiveY)}
          >
            <EdgeArrow />
          </Toggle>
        </div>

        <div className="flex justify-center">
          <Toggle
            value={values?.negativeX}
            onClick={() => onToggle?.(!(values?.negativeX ?? false), EdgeDistanceToggleType.NegativeX)}
          >
            <EdgeArrow className="-rotate-90" />
          </Toggle>
        </div>

        <div className="flex justify-center">
          <Toggle
            value={values?.thickness}
            onClick={() => onToggle?.(!(values?.thickness ?? false), EdgeDistanceToggleType.Thickness)}
          />
        </div>

        <div className="flex justify-center">
          <Toggle
            value={values?.positiveX}
            onClick={() => onToggle?.(!(values?.positiveX ?? false), EdgeDistanceToggleType.PositiveX)}
          >
            <EdgeArrow className="rotate-90" />
          </Toggle>
        </div>

        <div className="flex justify-center col-span-3">
          <Toggle
            value={values?.negativeY}
            onClick={() => onToggle?.(!(values?.negativeY ?? false), EdgeDistanceToggleType.NegativeY)}
          >
            <EdgeArrow className="rotate-180" />
          </Toggle>
        </div>
      </div>
    </div>
  )
}

const Toggle = ({ children, value, onClick }: TogglePropTypes) => {
  return (
    <button
      onClick={onClick}
      className={classNames('w-5 h-5 flex justify-center items-center', {
        'bg-primary-800 hover:bg-primary-900': value,
        'bg-gray-60 hover:bg-gray-200': !value,
      })}
    >
      {children}
    </button>
  )
}

export default EdgeDistanceToggle
